export default __webpack_public_path__ + "static/apple-touch-icon-ded0047dcef75d1b273913e5301ec6c4.png";